import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function AdminLayout() {
  const { email, roles, isAdmin, signOut } = useAuth();

  return (
    <div className="app-shell">
      <nav className="app-nav">
        <span className="brand">
          <img src="/phoenix-logo.png" alt="Phoenix Consulting" />
        </span>
        <NavLink to="/" end>
          Dashboard
        </NavLink>
        <NavLink to="/customers">Customers</NavLink>
        <NavLink to="/questions">Questions</NavLink>
        <div style={{ marginTop: 24, fontSize: '0.85em' }} className="muted">
          {email}
          <br />
          {roles.join(', ') || 'No role'}
        </div>
        <button onClick={signOut} style={{ marginTop: 16, width: '100%' }}>
          Sign out
        </button>
        {!isAdmin && (
          <p className="muted" style={{ fontSize: '0.8em', marginTop: 12 }}>
            View-only access
          </p>
        )}
      </nav>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
